import { createSelector } from 'reselect';

const getCorrelationCategories = state => state.dsaConfig && state.dsaConfig.correlationCategories;

export const getCorrelationsByCategory = state => {
  if (!state.dsaConfig.correlations) {
    return [];
  }

  const { correlationCategories, correlations } = state.dsaConfig;

  return correlationCategories.map(category => {
    return Object.assign({}, category, {
      correlations: correlations.filter(correlation => correlation.category === category.id)
    });
  });
};

const getCorrelations = state => state.dsaConfig && state.dsaConfig.correlations;
export const getDSACorrelations = state => state.dsa && state.dsa.dsaCorrelations;

export const getCorrelationsWithAnswersByCategory = createSelector(
  [getCorrelationsByCategory, getDSACorrelations],
  (categories, dsaCorrelations) => {
    if (!dsaCorrelations) {
      return categories;
    }

    return categories.map(category => {

      const answeredCorrelations = category.correlations.map(correlation => {
        const dsaCorrelation = dsaCorrelations.find(dsaCorrelation => dsaCorrelation.correlation === correlation.id);
        return Object.assign({}, correlation, dsaCorrelation);
      });

      return Object.assign({}, category, {
        correlations: answeredCorrelations
      });
    });
  }
);

export const getCorrelationsWithAnswersByCategoryWithProgress = createSelector(
  [getCorrelationsWithAnswersByCategory],
  (categories) => {
    return categories.map(category => {
      const answeredCorrelations = category.correlations.filter(correlation => correlation.answer !== null);
      return Object.assign({}, category, {
        answeredCount: answeredCorrelations.length
      });
    });
  }
);

export const getCompletedCorrelationCategoriesCount = createSelector(
  getCorrelationsWithAnswersByCategoryWithProgress,
  (categories) => {
    return categories.reduce((acc, category) => {
      if (category.answeredCount === category.correlations.length) {
        return acc + 1;
      }
      return acc;
    }, 0);
  }
);

export const getCorrelationsWithAnswers = createSelector(
  [getCorrelations, getDSACorrelations],
  (correlations, dsaCorrelations) => {
    if (!correlations || !dsaCorrelations) {
      return [];
    }

    return correlations.map(correlation => {
      const dsaCorrelation = dsaCorrelations.find(dsaCorrelation => dsaCorrelation.correlation === correlation.id);
      return Object.assign({}, correlation, dsaCorrelation);
    });
  }
);

export const getCorrelationsWithAnswersAndCategoryTitles = createSelector(
  [getCorrelationsWithAnswers, getCorrelationCategories],
  (correlations, categories) => {
    return correlations.map(correlation => {
      const category = categories.find(category => category.id === correlation.category);
      return Object.assign({}, correlation, { categoryTitle: category.title });
    });
  }
);


export const getEssentialCorrelations = createSelector(
  getCorrelationsWithAnswers,
  (correlationsWithAnswers) => {
    return correlationsWithAnswers.filter(correlation => correlation.critical);
  }
);

export const getAllCorrelations = getCorrelationsWithAnswers;

export const getAnsweredCorrelations = createSelector(
  getCorrelationsWithAnswers,
  (correlationsWithAnswers) => (
    correlationsWithAnswers.filter(correlation => correlation.answer !== null)
  )
);

export const getCriticalSecurityCorrelations = createSelector(
  [getCorrelationsWithAnswers],
  (correlations) => (
    correlations.filter(correlation => correlation.answer === 1)
  )
);




// WEBPACK FOOTER //
// ./src/selectors/dsa/correlationSelectors.js